import { FC } from 'react'

import { Typography } from '@mui/material'

import { ScoreboardCell } from './styles'

export type ScoreboardCellValue = string | number | null

export interface ScoreboardCellProps {
  title: string
  value?: ScoreboardCellValue
  testId: string
}

const EMPTY_VALUE = '-'

export const GolfScoreboardCell: FC<ScoreboardCellProps> = ({ title, value, testId }) => {
  return (
    <ScoreboardCell>
      <Typography variant="body2" data-testid={`${testId}-title`} sx={{ whiteSpace: 'nowrap' }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        fontWeight="bold"
        textAlign="center"
        data-testid={`${testId}-value`}
      >
        {value || EMPTY_VALUE}
      </Typography>
    </ScoreboardCell>
  )
}
